var flag1 = false,
    flag2 = false,
    readyForPopup = true;

function initPopup(options) {
    var sensor1 = $('<div class="exitpopupSensor1"></div>'),
        sensor2 = $('<div class="exitpopupSensor2"></div>');

    $('body')
        .append(sensor1)
        .append(sensor2);

    sensor1.mouseover(function() {
        if (flag2 == true) {
            flag1 = false;
            flag2 = false;

            if (readyForPopup) {
                var w = $(options.selector);
                if (typeof w.modal == 'function') {
                    w.modal('show');
                } else if (typeof w.plainModal == 'function') {
                    w.plainModal('open');
                }
                readyForPopup = false;
            }

        } else {
            flag1 = true;
            flag2 = false;
        }
    });

    sensor2.mouseover(function() {
        if (flag1 == true){
            flag2 = false;
            flag1 = false;
        } else {
            flag2 = true;
            flag1 = false;
        }
    });
}

module.exports = initPopup;